import * as pdfjs from 'pdfjs-dist';
import PdfJsWorker from 'pdfjs-dist/build/pdf.worker.min.mjs?worker';

let pending: Promise<void> | null = null;

/** Vite bundles the worker with a valid module MIME type (avoids nginx `.mjs` issues). */
export function configurePdfJsWorker(): Promise<void> {
  pending ??= Promise.resolve().then(() => {
    pdfjs.GlobalWorkerOptions.workerPort ??= new PdfJsWorker();
  });
  return pending;
}
